import { render, staticRenderFns } from "./frmLoss.vue?vue&type=template&id=01a3d9e2&scoped=true&"
import script from "./frmLoss.vue?vue&type=script&lang=js&"
export * from "./frmLoss.vue?vue&type=script&lang=js&"
import style0 from "./frmLoss.vue?vue&type=style&index=0&id=01a3d9e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3d9e2",
  null
  
)

export default component.exports